export const MODE_YEAR = 'YEAR';
export const MODE_MONTH = 'MONTH';
export const MODE_DATE = 'DATE';
export const ANCHOR_FROM = 'from';
export const ANCHOR_TO = 'to';
export const ANCHOR_NONE = '';
//# sourceMappingURL=constants.js.map